/**
 * Sentry wrapper para admin. Opt-in: si `VITE_SENTRY_DSN` no está seteada,
 * `initSentry()` es no-op.
 */

import * as Sentry from '@sentry/react';

let initialized = false;

export const initSentry = (): void => {
  if (initialized) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'production',
    release: import.meta.env.VITE_RELEASE,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
  });
  initialized = true;
};

export const setSentryUser = (userId: string, tenantId: string): void => {
  if (!initialized) return;
  Sentry.setUser({ id: userId });
  Sentry.setTag('tenantId', tenantId);
  Sentry.setTag('role', 'superadmin');
};

export const clearSentryUser = (): void => {
  if (!initialized) return;
  Sentry.setUser(null);
};

export const SentryErrorBoundary = Sentry.ErrorBoundary;
